module.exports = __webpack_public_path__ + "img/lines.b9d35808.svg";